import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHiveLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 68,
	viewBox: "0 0 70 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8176_9662)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.19434 19.8015C11.5479 20.1731 28.5793 21.3551 33.6392 21.7062C34.1818 21.743 34.7263 21.743 35.2689 21.7062L63.8057 19.8015C64.194 19.7751 64.4959 19.4436 64.4959 19.0434V15.2557C64.4959 14.565 63.9512 14.0052 63.2795 14.0052H6.7205C6.04865 14.0052 5.50422 14.565 5.50422 15.2557V19.0434C5.50422 19.4434 5.80598 19.7751 6.19434 19.8015Z",
				fill: "#FF5900"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0006 33.5452V28.3774C13.0006 27.796 12.56 27.3098 11.9824 27.2536L1.15354 26.2557C0.535277 26.1956 0 26.6822 0 27.3045V32.0375C0 32.5549 0.375022 32.9958 0.885003 33.0778L11.6948 34.6599C12.3798 34.7702 13.0006 34.2403 13.0006 33.5452Z",
				fill: "#FF5900"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.8467 26.2557L40.866 28.9744C36.9645 29.3534 33.0356 29.3534 29.134 28.9744C28.5957 28.9228 21.5821 28.2156 21.3135 28.2109C20.6512 28.1465 20.0776 28.668 20.0776 29.3346V35.1992C20.0776 35.7536 20.4796 36.2259 21.0259 36.3139L31.2982 37.9724C33.7529 38.3674 36.2548 38.3674 38.7094 37.9724L69.1151 33.0778C69.6251 32.9958 70 32.5549 70 32.0375V27.3045C70 26.6822 69.4648 26.1956 68.8467 26.2557Z",
				fill: "#FF5900"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.9091 54.1189L38.7047 59.7214C36.2764 60.363 33.7235 60.363 31.2951 59.7214C28.4363 58.966 12.5577 54.7706 10.0908 54.1189C9.35977 53.9256 8.64408 54.478 8.64408 55.2354V57.5438C8.64408 58.5251 9.25659 59.4017 10.1771 59.7376C10.6387 59.9061 29.7866 66.8939 30.7635 67.2505C33.5023 68.25 36.5052 68.2498 39.244 67.25L59.8231 59.7379C60.7435 59.4017 61.356 58.5252 61.356 57.544V55.2354C61.356 54.478 60.6402 53.9256 59.9091 54.1189Z",
				fill: "#FF5900"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.7812 6.96059H54.219C55.0403 6.96059 55.7063 6.29343 55.7063 5.47064V3.00308C55.7063 2.22955 55.1154 1.58472 54.3462 1.51855L38.3312 0.141321C36.7954 0.0092417 35.2539 -0.0291912 33.7146 0.0215565C33.1185 -0.0350887 16.786 1.43942 15.6539 1.51855C14.8846 1.58472 14.2937 2.22955 14.2937 3.00295V5.47064C14.2937 6.29343 14.9598 6.96059 15.7812 6.96059Z",
				fill: "#FF5900"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.4396 40.0773L39.9774 44.6175C36.6824 45.1829 33.3177 45.1829 30.0228 44.6175C23.5938 43.5145 10.0577 41.1921 3.56051 40.0773C2.86582 39.9581 2.23264 40.5033 2.23264 41.2207V44.6006C2.23264 45.135 2.59131 45.6001 3.10109 45.7268C10.1216 47.4731 24.5794 51.0692 31.6497 52.8277C33.8534 53.3758 36.1541 53.3758 38.3579 52.8276L66.8991 45.7269C67.4088 45.6001 67.7674 45.135 67.7674 44.6006V41.2207C67.7674 40.5033 67.1342 39.9581 66.4396 40.0773Z",
				fill: "#FF5900"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8176_9662",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 70,
			height: 68,
			fill: "white"
		})
	}) })]
});
export default SvgHiveLogo;
